/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GenerationRefundResponse interface.
 */
export function instanceOfGenerationRefundResponse(value) {
    if (!('alreadyRefunded' in value) || value['alreadyRefunded'] === undefined)
        return false;
    if (!('refunded' in value) || value['refunded'] === undefined)
        return false;
    return true;
}
export function GenerationRefundResponseFromJSON(json) {
    return GenerationRefundResponseFromJSONTyped(json, false);
}
export function GenerationRefundResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'alreadyRefunded': json['already_refunded'],
        'refunded': json['refunded'],
    };
}
export function GenerationRefundResponseToJSON(json) {
    return GenerationRefundResponseToJSONTyped(json, false);
}
export function GenerationRefundResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'already_refunded': value['alreadyRefunded'],
        'refunded': value['refunded'],
    };
}
